import React from "react";

const VideoPlayer = () => {
  return (
    <div className="relative aspect-video w-full bg-gray-900 rounded-lg overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center">
        <p className="text-gray-400">Interactive Demo Video Player</p>
      </div>
    </div>
  );
};

export default VideoPlayer;